import {createRouter} from 'vue-router';
import routes from './routes.js';

export default (options, isServer = false) => {
    const router =  createRouter({
        routes,
        ...options
    });
    if(!isServer) {
        router.beforeEach((to, from) => {
            const nearestTitle = to.matched.slice().reverse().find(route => route?.meta?.head?.title);
            const nearestMeta = to.matched.slice().reverse().find(route => route?.meta?.head?.meta);
            const previousTitle = from.matched.slice().reverse().find(route => route?.meta?.head?.title);

            if (nearestTitle) {
                document.title = nearestTitle.meta.head.title;
            } else if (previousTitle) {
                document.title = previousTitle.meta.head.title;
            }

            Array.from(document.querySelectorAll('[data-controlled]')).map(el => el.parentNode.removeChild(el));

            if (nearestMeta) {

                nearestMeta.meta.head.meta.map(tag => {
                        const el = document.createElement('meta');
                        Object.keys(tag).forEach(key => {
                            el.setAttribute(key, tag[key]);
                        });
                        el.setAttribute('data-controlled', '');
                        return el;
                    })
                    .forEach(tag => document.head.appendChild(tag));

            }

        });
    }

    return router;
};
